import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { getBaseURL } from '../../services/getBaseURL';
import HttpClient from '../../services/HttpClient';
import { getUserToken } from '../../services/utils';

const http = new HttpClient();
const baseURL = getBaseURL().wallet;

const initialState = {
	documentList: [],
	categoriesList: [],
	documentItem: undefined,
	isLoading: false,
	stateOtpSend: {},
	mehrAccountInfo: {
		Mobile: '',
		EnName: '',
		EnFamily: '',
		BankHesabNumber: '',
	},
	bankVerify: {
		CBIStatus: '',
		Flag: '',
	},
	bankValidation: null,
	errorOtp: false,
	confirmState: null,
	statusAPI: '',
	bankVerifyStatus: null,
	hasTamin: {},
	jobStatus: {},
	videoAuthentication: {},
};

// getWalletDocuments
export const getWalletDocuments = createAsyncThunk('/GetDocument', async (params, thunkAPI) => {
	const { walletRequestID, isToastfy, Position } = params;

	const body = {
		WalletRequestID: walletRequestID,
		Position,
	};

	let token = getUserToken(thunkAPI);
	const extraConfig = {
		headers: {
			// 'Authorization': 'berear 33e0a44b-b27a-47b1-adb3-e92b8ad59738',
			'Authorization': token,
		},
	};

	const response = await http
		.post(`${baseURL}/GetDocument`, body, extraConfig, isToastfy)
		.then((res) => res.data);
	return response;
});

// showItemOfDocument
export const showItemOfDocument = createAsyncThunk('/showItemOfDocument', async (params, thunkAPI) => {
	const { walletRequestID, isToastfy, Position } = params;

	const body = {
		WalletRequestID: walletRequestID,
		Position,
	};

	let token = getUserToken(thunkAPI);
	const extraConfig = {
		headers: {
			'Authorization': token,
			// 'Authorization': 'berear 33e0a44b-b27a-47b1-adb3-e92b8ad59738',
		},
	};

	const response = await http
		.post(`${baseURL}/GetDocument`, body, extraConfig, isToastfy)
		.then((res) => res.data);
	return response;
});

// showItemOfDocument
export const getWalletStatusDocument = createAsyncThunk(
	'/getWalletStatusDocument',
	async (params, thunkAPI) => {
		const { walletRequestID, isToastfy, Position } = params;

		const body = {
			WalletRequestID: walletRequestID,
			Position,
		};

		let token = getUserToken(thunkAPI);
		const extraConfig = {
			headers: {
				'Authorization': token,
				// 'Authorization': 'berear 33e0a44b-b27a-47b1-adb3-e92b8ad59738',
			},
		};

		const response = await http
			.post(`${baseURL}/GetDocument`, body, extraConfig, isToastfy)
			.then((res) => res.data);
		return response;
	},
);

// setter
export const setWalletDocuments = createAsyncThunk('/Wallet/SetDocument', async (requestBody, thunkAPI) => {
	let token = getUserToken(thunkAPI);
	const config = {
		...requestBody?.config,
		headers: {
			'Authorization': token,
			// WalletRequestID: 10005,
			// 'Authorization': 'brear 496A94E4-5B3D-4394-98BF-12F1C14852D7',
		},
	};

	const response = await http
		.post(`${baseURL}/SetDocument`, requestBody?.data, config, requestBody?.isToastfy)
		.then((res) => res.data);
	return response;
});

// delete
export const deleteWalletDocument = createAsyncThunk(
	'/Wallet/DeleteDocument ',
	async (requestBody, thunkAPI) => {
		let token = getUserToken(thunkAPI);

		const extraConfig = {
			headers: {
				'Authorization': token,
				// 'Authorization': 'berear 33e0a44b-b27a-47b1-adb3-e92b8ad59738',
			},
		};

		const response = await http
			.post(`${baseURL}/DeleteDocument `, requestBody, extraConfig, requestBody?.isToastfy)
			.then((res) => res.data);
		return response;
	},
);

///sendOtp
export const getWalletSendOtp = createAsyncThunk('/', async (params, thunkAPI) => {
	let token = getUserToken(thunkAPI);

	const extraConfig = {
		headers: {
			'Authorization': token,
			// 'Authorization': 'berear 33e0a44b-b27a-47b1-adb3-e92b8ad59738',
		},
	};

	const param = {
		WalletRequestID: params?.WalletRequestID,
	};

	const response = await http.post(`${baseURL}/WalletSendOtp`, param, extraConfig).then((res) => res.data);
	return response;
});

///ResendOtp
export const getWalletReSendOtp = createAsyncThunk('/otp', async (params, thunkAPI) => {
	let token = getUserToken(thunkAPI);

	const extraConfig = {
		headers: {
			// 'Authorization': 'berear 33e0a44b-b27a-47b1-adb3-e92b8ad59738',
			'Authorization': token,
		},
	};

	const param = {
		WalletRequestID: params.WalletRequestID, // params.WalletRequestID,
	};

	const response = await http.post(`${baseURL}/WalletReSendOtp`, param, extraConfig).then((res) => res.data);
	return response;
});

///otp Confirm
export const WalletConfirmOtp = createAsyncThunk('/otpConfirm', async (params, thunkAPI) => {
	let token = getUserToken(thunkAPI);

	const extraConfig = {
		headers: {
			// 'Authorization': 'berear 33e0a44b-b27a-47b1-adb3-e92b8ad59738',
			'Authorization': token,
		},
	};

	const param = {
		WalletRequestID: params.WalletRequestID, // params.WalletRequestID,
		Otp: params.Otp,
	};

	const response = await http.post(`${baseURL}/WalletConfirmOtp`, param, extraConfig).then((res) => res.data);
	return response;
});

export const CBIVerification = createAsyncThunk('wallet/CBIVerification', async (params, thunkAPI) => {
	const { walletRequestID, isToastfy } = params;

	let token = getUserToken(thunkAPI);

	const extraConfig = {
		headers: {
			'Authorization': token,
		},
	};
	const param = {
		walletRequestID: walletRequestID,
	};
	const response = await http
		.post(`${baseURL}/CBIVerification`, param, extraConfig, isToastfy)
		.then((res) => res.data);
	return response;
});

export const checkCustomerStatus = createAsyncThunk('/checkCustomerStatus', async (params, thunkAPI) => {
	const { walletRequestID, isToastfy } = params;

	let token = getUserToken(thunkAPI);

	const extraConfig = {
		headers: {
			'Authorization': token,
		},
	};
	const param = {
		walletRequestID: walletRequestID,
	};
	const response = await http
		.post(`${baseURL}/CheckCustomerStatus`, param, extraConfig, isToastfy)
		.then((res) => res.data);
	return response;
});

export const confirmCustomerStatus = createAsyncThunk('/confirmCustomerStatus', async (params, thunkAPI) => {
	const { WalletRequestID, isToastfy } = params;

	let token = getUserToken(thunkAPI);

	const extraConfig = {
		headers: {
			'Authorization': token,
		},
	};
	const param = {
		walletRequestID: WalletRequestID,
	};
	const response = await http
		.post(`${baseURL}/CheckCustomerStatusConfirm`, param, extraConfig, isToastfy)
		.then((res) => res.data);
	return response;
});

// check
export const checkJobAuthStatus = createAsyncThunk('/LiveVideo', async (params, thunkAPI) => {
	const { walletRequestID, isToastfy } = params;

	const body = {
		WalletRequestID: walletRequestID,
	};

	let token = getUserToken(thunkAPI);
	const extraConfig = {
		headers: {
			'Authorization': token,
		},
	};

	const response = await http
		.post(`${baseURL}/LiveVideo`, body, extraConfig, isToastfy)
		.then((res) => res.data);
	return response;
});

const walletRequestTwo = createSlice({
	name: 'walletRequestTwo',
	initialState,
	reducers: {
		setWalletCreditInfoNewFlow(state, action) {
			state.walletCreditInfo = action.payload;
		},

		clearDocumentItem(state) {
			state.documentList = [];
		},

		clearDocumentList(state) {
			state.documentList = [];
			state.categoriesList = [];
			state.documentItem = {};
		},
	},
	extraReducers: (builder) => {
		builder
			.addCase(getWalletDocuments.pending, (state) => {
				state.isLoading = true;
			})
			.addCase(getWalletDocuments.fulfilled, (state, action) => {
				const { Content, Success } = action.payload;
				if (Success) {
					state.categoriesList = Content?.Categories || [];
				}
				state.isLoading = false;
			})
			.addCase(getWalletDocuments.rejected, (state) => {
				state.isLoading = false;
			});
		builder
			.addCase(showItemOfDocument.pending, (state) => {
				state.isLoading = true;
			})
			.addCase(showItemOfDocument.fulfilled, (state, action) => {
				const { Content } = action.payload;

				state.isLoading = false;
				state.documentList = Content?.Documents || [];
				state.categoriesList = Content?.Categories || [];
			})
			.addCase(showItemOfDocument.rejected, (state) => {
				state.isLoading = false;
			});
		builder
			.addCase(setWalletDocuments.pending, (state) => {
				state.isLoading = true;
				state.statusAPI = 'pending';
			})
			.addCase(setWalletDocuments.fulfilled, (state, action) => {
				const { Success, Content } = action.payload;
				state.isLoading = false;
				state.statusAPI = Success ? 'success' : 'error';
				state.documentItem = Content?.Documents;
			})
			.addCase(setWalletDocuments.rejected, (state) => {
				state.isLoading = false;
				state.statusAPI = 'error';
			});
		builder
			.addCase(getWalletStatusDocument.pending, (state) => {
				state.isLoading = true;
			})
			.addCase(getWalletStatusDocument.fulfilled, (state, action) => {
				const { Content } = action.payload;
				state.isLoading = false;
				const foundWalletOne = Content.Categories.find((item) => item.Key === 'Wallet.1');

				state.jobStatus = foundWalletOne?.Status;
			})
			.addCase(getWalletStatusDocument.rejected, (state) => {
				state.isLoading = false;
			});
		builder
			.addCase(deleteWalletDocument.pending, (state) => {
				state.isLoading = true;
			})
			.addCase(deleteWalletDocument.fulfilled, (state, action) => {
				const { Success } = action.payload;
				state.isLoading = false;
				state.statusAPI = Success ? 'success' : 'error';

				// const result = state.categoriesList.map((item) => {
				// 	if (
				// 		item.Document?.WalletSponsorConditionDocumentID ===
				// 		action.meta.arg?.WalletSponsorConditionDocumentID
				// 	) {
				// 		return {
				// 			...item,
				// 			Status: { Message: '', Type: '' },
				// 			Document: {
				// 				...item.Document,
				// 				CurrentValueURL: null,
				// 				Status: { Message: '', Type: '' },
				// 			},
				// 		};
				// 	}
				// 	return item;
				// });

				// state.categoriesList = result;
			})
			.addCase(deleteWalletDocument, (state) => {
				state.isLoading = false;
				state.statusAPI = 'error';
			});
		builder
			.addCase(getWalletSendOtp.pending, (state) => {
				state.isLoading = true;
			})
			.addCase(getWalletSendOtp.fulfilled, (state, action) => {
				const { Content } = action.payload;
				state.isLoading = false;
				state.stateOtpSend = Content;
			})
			.addCase(getWalletSendOtp.rejected, (state) => {
				state.isLoading = false;
			});

		builder
			.addCase(checkCustomerStatus.pending, (state) => {
				state.isLoading = true;
			})
			.addCase(checkCustomerStatus.fulfilled, (state, action) => {
				const { Content } = action.payload;
				state.isLoading = false;
				state.hasTamin = Content;
			})
			.addCase(checkCustomerStatus.rejected, (state) => {
				state.isLoading = false;
			});

		builder
			.addCase(confirmCustomerStatus.pending, (state) => {
				state.isLoading = true;
			})
			.addCase(confirmCustomerStatus.fulfilled, (state) => {
				state.isLoading = false;
				// state.hasTamin = Content;
			})
			.addCase(confirmCustomerStatus.rejected, (state) => {
				state.isLoading = false;
			});
		builder
			.addCase(getWalletReSendOtp.pending, (state) => {
				state.isLoading = true;
			})
			.addCase(getWalletReSendOtp.fulfilled, (state, action) => {
				const { Content, Success } = action.payload;
				state.isLoading = false;
				if (Success) {
					state.stateOtpSend = Content;
				}
			})
			.addCase(getWalletReSendOtp.rejected, (state) => {
				state.isLoading = false;
			});
		builder
			.addCase(WalletConfirmOtp.pending, (state) => {
				state.isLoading = true;
			})
			.addCase(WalletConfirmOtp.fulfilled, (state, action) => {
				const { Success, Content } = action.payload;
				if (Success) {
					state.confirmState = Content;
					state.errorOtp = false;
				} else {
					state.errorOtp = true;
				}
			})
			.addCase(WalletConfirmOtp.rejected, (state) => {
				state.isLoading = false;
			});
		builder
			.addCase(CBIVerification.pending, (state) => {
				state.status = 'pending';
				state.isLoading = true;
			})
			.addCase(CBIVerification.fulfilled, (state, action) => {
				const { Content, Success, Message, Status } = action.payload;

				state.bankValidation = {
					Message,
					Status,
					Content,
				};

				if (Success) {
					state.bankVerify.CBIStatus = Content?.CBIStatus;
					state.bankVerify.Flag = Content.Flag;
					state.bankVerifyStatus = Content.Status;
					state.isLoading = false;
				} else {
					state.bankVerify.CBIStatus = false;
					state.isLoading = false;
				}
			})
			.addCase(CBIVerification.rejected, (state, action) => {
				const { Message, Status, Content } = action.payload;
				state.status = 'error';
				state.isLoading = false;
				state.bankValidation = {
					Message,
					Status,
					Content,
				};
			});
		builder
			.addCase(checkJobAuthStatus.pending, (state) => {
				state.isLoading = true;
			})
			.addCase(checkJobAuthStatus.fulfilled, (state, action) => {
				state.isLoading = false;
				state.videoAuthentication = action.payload;
			})
			.addCase(checkJobAuthStatus.rejected, (state, action) => {
				state.isLoading = false;
				state.videoAuthentication = action.payload;
			});
	},
});
export const { clearDocumentList, clearDocumentItem } = walletRequestTwo.actions;
export default walletRequestTwo.reducer;
